import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Country {
  id: number;
  name: string;
  name_en: string;
  full_name: string;
  full_name_en: string;
  code: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private countries: Country[] = [];

  constructor(private http: HttpClient) {}

  /**
   * Load countries from JSON file
   */
  loadCountries(): Observable<Country[]> {
    if (this.countries.length > 0) {
      return of(this.countries);
    }

    return this.http.get<Country[]>('/assets/data/simple-countries.json').pipe(
      map((countries) => {
        this.countries = countries;
        return countries;
      })
    );
  }

  /**
   * Get all countries (synchronous)
   */
  getCountries(): Country[] {
    return this.countries;
  }

  /**
   * Get country by ID
   */
  getCountryById(countryId: number): Country | undefined {
    return this.countries.find((c) => c.id === countryId);
  }
}
